import '../../scripts/common';

import '../../scripts/autosize';
import 'animate.css/animate.css';
import '../../scripts/animate';
import '../../scripts/picture';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import EventsList from '../../components/EventsList';
import EventCard from '../../components/EventCard';
import Pagination from '../../components/base/Pagination';
import PageScrollBtn from '../../components/simple/PageScrollBtn';

import './styles.css';

$(() => {
    Header.create();
    Footer.create();
    EventsList.create();
    Pagination.create();
    initEventCard();
    PageScrollBtn.create();
});

/**
 * Инициализация карточек событий
 */
function initEventCard() {
    $('.event-card').each((i, item) => {
        const eventDefault = new EventCard($(item));
        eventDefault.init({});
    });
}
